import { Checkbox } from '@avanta/shared/components/ui/Checkbox';
import { cn } from '@avanta/shared/utils/cn';
import { CHECKBOX_CHECKED, CHECKBOX_UNCHECKED } from '../../../styles';

interface CheckboxCardProps {
  id: string;
  label: string | React.ReactNode;
  description?: string;
  checked: boolean;
  className?: string;
  containerClassName?: string;
  icon: React.ElementType;
  onCheckedChange: (checked: boolean) => void;
  fullWidthMode?: boolean;
}

export const CheckboxCard = ({
  id,
  label,
  description,
  checked,
  icon: Icon,
  className,
  containerClassName,
  fullWidthMode = false,
  onCheckedChange,
}: CheckboxCardProps): React.ReactElement => (
  <Checkbox
    id={id}
    checked={checked}
    onCheckedChange={onCheckedChange}
    className={containerClassName}
  >
    <div
      className={cn(
        'flex w-full px-4 py-2 am-lg:py-4 flex-col items-center justify-center gap-1 am-lg:gap-2 rounded-xl',
        checked ? CHECKBOX_CHECKED : CHECKBOX_UNCHECKED,
        fullWidthMode && 'flex-row gap-4 am-lg:gap-2 am-lg:flex-col',
        className
      )}
    >
      <Icon
        strokeWidth={1.5}
        className={cn('size-8 am-lg:size-10 shrink-0 text-teal-600', checked && 'text-teal-700')}
      />
      <label
        className="am-lg:text-sm text-xs leading-4 font-medium whitespace-pre-line"
        htmlFor={id}
      >
        {label}
      </label>
      {description && (
        <p className="am-lg:text-sm text-xs leading-4 font-normal text-gray-400">{description}</p>
      )}
    </div>
  </Checkbox>
);
